// extracted by mini-css-extract-plugin
export default {"mainContent":"MassIncreaseProduct_mainContent__9uQj6","placeHolderShimmer":"MassIncreaseProduct_placeHolderShimmer__UH9fZ"};